import { motion } from "framer-motion";

const DIVISIONS = [
  ["Minimumweight", "Up to 105 lbs", "Up to 47.627 kgs"],
  ["Light Flyweight", "Up to 108 lbs", "Up to 48.987 kgs"],
  ["Flyweight", "Up to 112 lbs", "Up to 50.802 kgs"],
  ["Super Flyweight", "Up to 115 lbs", "Up to 52.163 kgs"],
  ["Bantamweight", "Up to 118 lbs", "Up to 53.524 kgs"],
  ["Super Bantamweight", "Up to 122 lbs", "Up to 55.338 kgs"],
  ["Featherweight", "Up to 126 lbs", "Up to 57.153 kgs"],
  ["Super Featherweight", "Up to 130 lbs", "Up to 58.967 kgs"],
  ["Lightweight", "Up to 135 lbs", "Up to 61.235 kgs"],
  ["Super Lightweight", "Up to 140 lbs", "Up to 63.503 kgs"],
  ["Welterweight", "Up to 147 lbs", "Up to 66.678 kgs"],
  ["Super Welterweight", "Up to 154 lbs", "Up to 69.853 kgs"],
  ["Middleweight", "Up to 160 lbs", "Up to 72.575 kgs"],
  ["Super Middleweight", "Up to 168 lbs", "Up to 76.204 kgs"],
  ["Light Heavyweight", "Up to 175 lbs", "Up to 79.379 kgs"],
  ["Cruiserweight", "Up to 200 lbs", "Up to 90.719 kgs"],
  ["Bridgerweight", "Under 224 lbs", "Up to 101.605 kgs"],
  ["Heavyweight", "Over 224 lbs — no limit", "Over 101.605 kgs — no limit"],
];

function DivisionTable({ rows, testid }) {
  return (
    <div className="border border-zinc-800 bg-[#0d0d0d]" data-testid={testid}>
      <div className="grid grid-cols-3 font-mono2 text-[9px] sm:text-[10px] tracking-[0.25em] text-[#E10600] uppercase border-b border-zinc-800 px-4 py-3">
        <span>Division</span><span>Pounds</span><span>Kilograms</span>
      </div>
      {rows.map(([d, p, k], i) => (
        <div
          key={d}
          className={`grid grid-cols-3 px-4 py-3 text-sm transition-colors duration-300 hover:bg-[#161010] ${i % 2 ? "bg-[#101010]" : ""}`}
          data-testid={`division-row-${d.toLowerCase().replace(/\s+/g, "-")}`}
        >
          <span className="font-cond font-semibold uppercase tracking-wide text-white">{d}</span>
          <span className="text-zinc-400">{p}</span>
          <span className="text-zinc-500">{k}</span>
        </div>
      ))}
    </div>
  );
}

export default function WeightDivisions() {
  return (
    <section id="divisions" className="py-24 lg:py-32 border-t border-zinc-800/60" data-testid="divisions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <motion.p
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono2 text-[10px] sm:text-xs tracking-[0.4em] text-[#E10600] uppercase mb-4 flex items-center gap-4"
        >
          <span className="h-px w-10 bg-[#E10600]" /> IBC Rule 3 — Weight Classification
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white mb-4"
        >
          18 <span className="text-[#E10600]">sanctioned</span> divisions
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-base sm:text-lg text-zinc-400 leading-relaxed max-w-2xl mb-14"
        >
          Every MPB masters bout is contested in one of the eighteen IBC weight divisions —
          from Minimumweight all the way to Heavyweight with no upper limit.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-6"
        >
          <DivisionTable rows={DIVISIONS.slice(0, 9)} testid="divisions-table-1" />
          <DivisionTable rows={DIVISIONS.slice(9)} testid="divisions-table-2" />
        </motion.div>
      </div>
    </section>
  );
}
